// extracted by mini-css-extract-plugin
module.exports = {"container":"container--PanelWrapper-components__179Xs"};